var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "table-layout"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow-y": "auto",
      "overflow-x": "hidden",
      "max-height": "-webkit-fill-available"
    },
    attrs: {
      "id": "tableWrapperContainer"
    }
  }, [(_vm.show) ? _c('dyn-table-wrapper', {
    attrs: {
      "arrayToTable": _vm.arrayToTable,
      "focus": _vm.focus,
      "name": "WrapperGrid"
    }
  }) : _vm._e()], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b865f41","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sub-views/Table.vue
// module id = 1658
// module chunks = 1